import { render, staticRenderFns } from "./LimitFormulaCombo.vue?vue&type=template&id=6df0bdb9&scoped=true"
import script from "./LimitFormulaCombo.vue?vue&type=script&lang=js"
export * from "./LimitFormulaCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df0bdb9",
  null
  
)

export default component.exports